import { Table, TableHeader, TableCell, TableRow } from "@/components/ui/table";

/*
 * RecentStudiesSkeleton component
 * This component is used to show a skeleton loader for the recent studies table
 */
export const RecentStudiesSkeleton = () => {
  /* Render */
  return (
    <Table>
      {/* Header */}
      <thead>
        <TableRow>
          <TableHeader>Study name</TableHeader>
          <TableHeader>Project</TableHeader>
          <TableHeader>Use case</TableHeader>
          <TableHeader>Author</TableHeader>
          <TableHeader>Last edited</TableHeader>
          <TableHeader></TableHeader>
        </TableRow>
      </thead>

      {/* Body */}
      <tbody>
        {Array.from({ length: 10 }).map((_, index) => (
          <TableRow key={index}>
            <TableCell>
              <div className="flex items-center gap-3">
                <div className="skeleton w-12 h-12 rounded-lg" />
                <div className="flex flex-col gap-2">
                  <div className="skeleton h-4 w-32" />
                  <div className="skeleton h-3 w-20" />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-24" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-16" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-28" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-28" />
              </div>
            </TableCell>
            <TableCell>
              <div className="skeleton h-4 w-4 ml-auto" />
            </TableCell>
          </TableRow>
        ))}
      </tbody>
    </Table>
  );
};
